import React, { Component } from "react";
import FlexView from "react-flexview";
import * as R from "ramda";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import DailySalesReport from "./dailySalesReport";
import MonthToDateSalesReport from "./monthToDateSalesReport";
import MonthToDateCabangSalesReport from "./monthToDateCabangSalesReport";
import YearToDateSalesReport from "./yearToDateSalesReport";
import LastThreeYearSalesReport from "./lastThreeYearsSalesReport";
import { connect } from "react-redux";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import Container from "../../../../../modules/commons/Container";
import SimpleCheckBox from "../../../../../modules/SimpleCheckBox";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import { mapToObjectDDL } from "../../../../common/mapper";
import * as ErrorAction from "../../../../../Redux/ErrorRedux";
import { HttpStatus } from "../../../../common/Constants";

class KacabReportByCabang extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      isAllSelected: true,
      isSpecificSelected: false,
      month: null,
      year: null,
      dataCabang: [],
      kodeCabang: [],
      search: {},
      doSearch: false,
    };
  }

  componentDidMount = async () => {
    this.setState((prevValue) => ({
      ...prevValue,
    }));
    await this.fetchDataCabang();
    this.fetchLeaderId();
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (R.isNil(this.state.kodeCabang)) {
      this.setState((prevValue) => ({
        ...prevValue,
        kodeCabang: [],
      }));
    }
    if (!R.equals(prevState.doSearch, this.state.doSearch)) {
      console.log("doSearch", this.state.doSearch);
    }
  }

  fetchLeaderId = async () => {
    const idLeader = localStorage.getItem("idLeader");
    const userId = localStorage.getItem("userId");

    if (idLeader) {
      this.setState((prevValue) => ({
        ...prevValue,
        idLeader: idLeader,
      }));
      return;
    }
    this.handleTriggerLoading();
    try {
      let res = await fetchDataAsync({
        asyncFn: () => Api.create("NAGAMAS_MASTER_DATA").findUserById(userId),
        menuName:
          "Dashboard Level Kepala Cabang Keatas - Laporan Harian By Team Leader",
        setError: this.props.setError,
      });
      console.log(res);

      if (res.ok) {
        localStorage.setItem("idLeader", res.data.data.id);
        this.setState((prevValue) => ({
          ...prevValue,
          idLeader: res.data.data.id,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
    this.handleTriggerLoading();
  };

  handleChangeDoSearch = (value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      doSearch: value,
    }));
  };

  fetchDataCabang = async () => {
    this.handleTriggerLoading();
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      setError: this.props.setError,
      menuName:
        "Dashboard Level Kepala Cabang Keatas - Laporan Harian By Cabang",
      args: null,
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      let filteredData = res.data.data.filter((item) =>
        this.props.menuAccess
          .map((data) => data.idRefObj)
          .includes(item.kodeCabang),
      );
      console.log(filteredData);

      if (filteredData.length !== 0) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataCabang: filteredData,
        }));
      }
    }
    this.handleTriggerLoading();
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  handleSelectCabang = (e, type) => {
    const isChecked = e.target.checked;

    if (type === "ALL") {
      this.setState((prevValue) => ({
        ...prevValue,
        isAllSelected: isChecked,
        isSpecificSelected: false,
        kodeCabang: [],
      }));
    }

    if (type === "SPECIFIC") {
      this.setState((prevValue) => ({
        ...prevValue,
        isSpecificSelected: isChecked,
        isAllSelected: false,
        kodeCabang: [],
      }));
    }
  };

  handleSearch = () => {
    const { dataCabang, kodeCabang, isAllSelected, isSpecificSelected } =
      this.state;

    const kodeCabangList = isAllSelected
      ? dataCabang.map((item) => item.kodeCabang)
      : isSpecificSelected && kodeCabang?.length
        ? kodeCabang.map((item) => item.value)
        : [];

    this.setState((prev) => ({
      ...prev,
      search: kodeCabangList,
    }));
  };

  handleChangeCabang = (value) => {
    this.setState((prevValue) => ({ ...prevValue, kodeCabang: value }));
  };

  render() {
    return (
      <>
        <Container>
          <FlexView style={{ gap: "20px", alignItems: "center" }}>
            <SimpleCheckBox
              id="reportAllCabang"
              key="reportAllCabang"
              name="reportAllCabang"
              label="ALL CABANG"
              checked={this.state.isAllSelected}
              onChange={(e) => this.handleSelectCabang(e, "ALL")}
            />
            <SimpleCheckBox
              id="reportSpecificCabang"
              key="reportSpecificCabang"
              name="reportSpecificCabang"
              label="SPESIFIK CABANG"
              checked={this.state.isSpecificSelected}
              onChange={(e) => this.handleSelectCabang(e, "SPECIFIC")}
            />
            <SimpleDDL
              id="select_options_kode_cabang"
              box="multiselect"
              name="kodeCabang"
              containerclassname="width width-500px margin-top-15px"
              placeholder="Nama Cabang"
              readOnly={!this.state.isSpecificSelected}
              options={this.state.dataCabang.map((item) =>
                mapToObjectDDL(item.namaDealer, item.kodeCabang),
              )}
              value={this.state.kodeCabang}
              onChange={(value) => this.handleChangeCabang(value)}
            />
            <SimpleButton
              styles={{ marginBottom: "20px" }}
              onClick={this.handleSearch}
            >
              Cari
            </SimpleButton>
          </FlexView>
          <Tabs>
            <TabList>
              <Tab>Laporan Jualan Harian</Tab>
              <Tab>Laporan Jualan Month To Date</Tab>
              <Tab>Laporan Jualan Month To Date By Cabang</Tab>
              <Tab>Laporan Year To Date</Tab>
              <Tab>Laporan Jualan 3 Tahun Terakhir</Tab>
            </TabList>
            <TabPanel>
              <DailySalesReport
                {...this.props}
                search={this.state.search}
                dataCabang={this.state.dataCabang}
                isAllSelected={this.state.isAllSelected}
                triggerLoading={this.handleTriggerLoading}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
            <TabPanel>
              <MonthToDateSalesReport
                {...this.props}
                search={this.state.search}
                dataCabang={this.state.dataCabang}
                isAllSelected={this.state.isAllSelected}
                kodeCabang={this.state.kodeCabang}
                triggerLoading={this.handleTriggerLoading}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
            <TabPanel>
              <MonthToDateCabangSalesReport
                {...this.props}
                kodeCabang={this.state.kodeCabang}
                search={this.state.search}
                dataCabang={this.state.dataCabang}
                isAllSelected={this.state.isAllSelected}
                triggerLoading={this.handleTriggerLoading}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
            <TabPanel>
              <YearToDateSalesReport
                {...this.props}
                search={this.state.search}
                kodeCabang={this.state.kodeCabang}
                triggerLoading={this.handleTriggerLoading}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
            <TabPanel>
              <LastThreeYearSalesReport
                {...this.props}
                search={this.state.search}
                kodeCabang={this.state.kodeCabang}
                triggerLoading={this.handleTriggerLoading}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
          </Tabs>
        </Container>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(null, mapDispatchToProps)(KacabReportByCabang);
